import { Skeleton } from 'antd'
import React from 'react'
import MainContainer from '../MainContainer'
export default function LoadPage() {
  return (
    <MainContainer>
        <Skeleton active loading />
    </MainContainer>
  )
}
